export enum AgentTypeName {
    Agent = 'Agent',
    Banca = 'Banca',
    Direct= 'Direct',
    Indirect = 'Indirect',
}